var map = {
	"./benifits-of-gamyfie-with-learning.jpg": 1353,
	"./correct-age-for-logical-thinking.jpg": 1354,
	"./five-ways-to-improve-child-decision-making.jpg": 1355,
	"./help-your-children.jpg": 1356,
	"./how-to-negotiate.jpg": 1357,
	"./infulacing-child-iq.jpg": 1358,
	"./tech-children-how-to-think.jpg": 1359,
	"./video-games.jpg": 1360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1585;